<div #ref>
    <ng-content></ng-content>
</div>
<ng-container *ngIf="ref.children.length === 0">
    <fc-ag-bubble [editor]="editor"></fc-ag-bubble>
</ng-container>
